// @generated by protoc-gen-es v1.10.0
// @generated from file omnios/v1/communication.proto (package omnios.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Struct, Timestamp } from "@bufbuild/protobuf";
import { FilterGroup, PageRequest, PageResponse, SortSpec } from "./common_pb.js";

/**
 * @generated from enum omnios.v1.ConversationKind
 */
export const ConversationKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.ConversationKind",
  [
    {no: 0, name: "CONVERSATION_KIND_UNSPECIFIED"},
    {no: 1, name: "DIRECT"},
    {no: 2, name: "GROUP"},
    {no: 3, name: "SYSTEM"},
    {no: 4, name: "CASE_THREAD"},
    {no: 5, name: "AGENT_THREAD"},
  ],
);

/**
 * @generated from enum omnios.v1.SenderKind
 */
export const SenderKind = /*@__PURE__*/ proto3.makeEnum(
  "omnios.v1.SenderKind",
  [
    {no: 0, name: "SENDER_KIND_UNSPECIFIED"},
    {no: 1, name: "USER"},
    {no: 2, name: "CUSTOMER"},
    {no: 3, name: "SYSTEM_SENDER"},
    {no: 4, name: "AI"},
  ],
);

/**
 * Conversation thread (replaces Chat)
 *
 * @generated from message omnios.v1.Conversation
 */
export const Conversation = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Conversation",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "kind", kind: "enum", T: proto3.getEnumType(ConversationKind) },
    { no: 6, name: "attrs", kind: "message", T: Struct },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
    { no: 11, name: "updated_at", kind: "message", T: Timestamp },
    { no: 20, name: "last_message", kind: "message", T: Message },
    { no: 21, name: "unread_count", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * Individual message in a conversation
 *
 * @generated from message omnios.v1.Message
 */
export const Message = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.Message",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "workspace_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sender_party_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "sender_kind", kind: "enum", T: proto3.getEnumType(SenderKind) },
    { no: 6, name: "content", kind: "message", T: MessageContent, repeated: true },
    { no: 7, name: "reply_to_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "created_at", kind: "message", T: Timestamp },
  ],
);

/**
 * Content block within a message
 *
 * @generated from message omnios.v1.MessageContent
 */
export const MessageContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.MessageContent",
  () => [
    { no: 1, name: "text", kind: "message", T: TextContent, oneof: "content" },
    { no: 2, name: "image", kind: "message", T: ImageContent, oneof: "content" },
    { no: 3, name: "file", kind: "message", T: FileContent, oneof: "content" },
    { no: 4, name: "audio", kind: "message", T: AudioContent, oneof: "content" },
    { no: 5, name: "video", kind: "message", T: VideoContent, oneof: "content" },
  ],
);

/**
 * @generated from message omnios.v1.TextContent
 */
export const TextContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.TextContent",
  () => [
    { no: 1, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ImageContent
 */
export const ImageContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ImageContent",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "thumbnail_urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "width", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "height", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.FileContent
 */
export const FileContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.FileContent",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "size_bytes", kind: "scalar", T: 3 /* ScalarType.INT64 */ },
    { no: 5, name: "mime_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.AudioContent
 */
export const AudioContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.AudioContent",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "duration_ms", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.VideoContent
 */
export const VideoContent = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.VideoContent",
  () => [
    { no: 1, name: "media_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "thumbnail_urn", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "duration_ms", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.CreateConversationRequest
 */
export const CreateConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.CreateConversationRequest",
  () => [
    { no: 1, name: "channel_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "kind", kind: "enum", T: proto3.getEnumType(ConversationKind) },
    { no: 4, name: "attrs", kind: "message", T: Struct },
  ],
);

/**
 * @generated from message omnios.v1.GetConversationRequest
 */
export const GetConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.GetConversationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ListConversationsRequest
 */
export const ListConversationsRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListConversationsRequest",
  () => [
    { no: 1, name: "page", kind: "message", T: PageRequest },
    { no: 2, name: "filter", kind: "message", T: FilterGroup },
    { no: 3, name: "sort", kind: "message", T: SortSpec },
    { no: 4, name: "kind", kind: "enum", T: proto3.getEnumType(ConversationKind), opt: true },
  ],
);

/**
 * @generated from message omnios.v1.ListConversationsResponse
 */
export const ListConversationsResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListConversationsResponse",
  () => [
    { no: 1, name: "conversations", kind: "message", T: Conversation, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.SendMessageRequest
 */
export const SendMessageRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendMessageRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "content", kind: "message", T: MessageContent, repeated: true },
    { no: 3, name: "reply_to_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sender_kind", kind: "enum", T: proto3.getEnumType(SenderKind) },
  ],
);

/**
 * @generated from message omnios.v1.ListMessagesRequest
 */
export const ListMessagesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMessagesRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "page", kind: "message", T: PageRequest },
    { no: 3, name: "before", kind: "message", T: Timestamp },
    { no: 4, name: "after", kind: "message", T: Timestamp },
  ],
);

/**
 * @generated from message omnios.v1.ListMessagesResponse
 */
export const ListMessagesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ListMessagesResponse",
  () => [
    { no: 1, name: "messages", kind: "message", T: Message, repeated: true },
    { no: 2, name: "page", kind: "message", T: PageResponse },
  ],
);

/**
 * @generated from message omnios.v1.StreamMessagesRequest
 */
export const StreamMessagesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.StreamMessagesRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.UpdateConversationRequest
 */
export const UpdateConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.UpdateConversationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "subject", kind: "scalar", T: 9 /* ScalarType.STRING */, opt: true },
  ],
);

/**
 * @generated from message omnios.v1.DeleteConversationRequest
 */
export const DeleteConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteConversationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.DeleteConversationResponse
 */
export const DeleteConversationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.DeleteConversationResponse",
  [],
);

/**
 * @generated from message omnios.v1.ArchiveConversationRequest
 */
export const ArchiveConversationRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ArchiveConversationRequest",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.ArchiveConversationResponse
 */
export const ArchiveConversationResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.ArchiveConversationResponse",
  [],
);

/**
 * @generated from message omnios.v1.SendEmailReplyRequest
 */
export const SendEmailReplyRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendEmailReplyRequest",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "body", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message omnios.v1.SendEmailReplyResponse
 */
export const SendEmailReplyResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SendEmailReplyResponse",
  () => [
    { no: 1, name: "message", kind: "message", T: Message },
  ],
);

/**
 * @generated from message omnios.v1.SearchMessagesRequest
 */
export const SearchMessagesRequest = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchMessagesRequest",
  () => [
    { no: 1, name: "query", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message omnios.v1.SearchMessagesResponse
 */
export const SearchMessagesResponse = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchMessagesResponse",
  () => [
    { no: 1, name: "hits", kind: "message", T: SearchMessageHit, repeated: true },
  ],
);

/**
 * @generated from message omnios.v1.SearchMessageHit
 */
export const SearchMessageHit = /*@__PURE__*/ proto3.makeMessageType(
  "omnios.v1.SearchMessageHit",
  () => [
    { no: 1, name: "conversation_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "conversation_subject", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "text", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "sender_kind", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

